import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import "./SideBar.scss";

import logo from "assets/logo.svg";
import { NavLink, useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import Button from "components/atoms/Button";
import { useAppSelector } from "redux/hooks";

import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import AuthService from "services/auth.service";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
export default function SideBar({
  state,
  toggleDrawer,
  englishLang,
  arabicLang,
}: any) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("translation");
  const [open, setOpen] = React.useState(false);
  const [langOpen, setLangOpen] = React.useState(false);
  const user = useAppSelector((state) => state.auth.user);

  const toggleOpen = () => {
    setOpen(!open);
  };

  const toggleLangOpen = () => {
    setLangOpen(!langOpen);
  };

  const renderExpandIcon = (expanded = false) =>
    i18n.language === "ar" ? (
      <FaAngleLeft
        style={{
          fontSize: "16px",
          marginRight: "auto",
          transition: "transform 0.2s ease",
          transform: expanded ? "rotate(-90deg)" : "rotate(0deg)",
        }}
      />
    ) : (
      <FaAngleRight
        style={{
          fontSize: "16px",
          marginLeft: "auto",
          transition: "transform 0.2s ease",
          transform: expanded ? "rotate(90deg)" : "rotate(0deg)",
        }}
      />
    );

  const dropdownLinks = [
    {
      path: `/airport-transfers`,
      text: t("airportTransfers"),
    },
    {
      path: `/chauffeur-service`,
      text: t("chauffeurService"),
    },
    {
      path: `/limousine-service`,
      text: t("limousineService"),
    },
    {
      path: `/city-to-city-transfer`,
      text: t("City to City Transfer"),
    },
    { path: `/hire-by-the-hour`, text: t("hourlyBasis") },
    { path: `/event-transportation`, text: t("eventBasis") },
  ];

  const list = (state: any) => (
    <Box sx={{ width: "100%" }} role="presentation" onKeyDown={toggleDrawer}>
      <div className="sidebar__container">
        <div className="header">
          <Box display={"flex"}>
            <img src={logo} alt="" />
          </Box>
          <CloseIcon onClick={toggleDrawer} className="sideCross" />
        </div>
        <div className="side__links">
          <span className="dropdown link_side" onClick={toggleOpen}>
            {t("services")}
            {renderExpandIcon(open)}
          </span>
          {open && (
            <Box px={2} bgcolor={"#ffffff"}>
              {dropdownLinks.map((service, index) => (
                <NavLink
                  key={index}
                  className="dropdown"
                  onClick={toggleDrawer}
                  to={service.path}
                >
                  {service.text}
                </NavLink>
              ))}
            </Box>
          )}
          <NavLink className="dropdown" onClick={toggleDrawer} to={`/business`}>
            {t("business")}
          </NavLink>

          <NavLink
            className="dropdown"
            onClick={toggleDrawer}
            to={`/global-reach`}
          >
            {t("GlobalReach")}
          </NavLink>

          {user && (
            <>
              <NavLink
                className="dropdown"
                onClick={toggleDrawer}
                to={`/profile`}
              >
                {t("profile")}
              </NavLink>
              <NavLink
                className="dropdown"
                onClick={toggleDrawer}
                to={`/bookings`}
              >
                {t("bookings")}
              </NavLink>
              <NavLink
                className="dropdown"
                onClick={toggleDrawer}
                to={`/billing`}
              >
                {t("billingAddress")}
              </NavLink>
              <NavLink
                className="dropdown"
                onClick={toggleDrawer}
                to={`/wallet`}
              >
                {t("wallet")}
              </NavLink>
            </>
          )}
          <span className="dropdown link_side" onClick={toggleLangOpen}>
            {i18n.language === "en" ? "EN" : "عربي"}
            {renderExpandIcon(langOpen)}
          </span>
          {langOpen && (
            <Box px={2} bgcolor={"#ffffff"}>
              <span
                className="dropdown"
                style={{
                  cursor: "pointer",
                  padding: "16px 0",
                  borderBottom: "1px solid #e4e4e4",
                  fontSize: "17px",
                  fontWeight: 500,
                  color: i18n.language === "en" ? "#520A76" : "#020405",
                }}
                onClick={() => { englishLang(); toggleDrawer(); }}
              >
                EN
              </span>
              <span
                className="dropdown"
                style={{
                  cursor: "pointer",
                  padding: "16px 0",
                  borderBottom: "1px solid #e4e4e4",
                  fontSize: "17px",
                  fontWeight: 500,
                  color: i18n.language === "ar" ? "#520A76" : "#020405",
                }}
                onClick={() => { arabicLang(); toggleDrawer(); }}
              >
                عربي
              </span>
            </Box>
          )}
        </div>

        {
          <Stack style={{ padding: "30px 10px" }} spacing={1}>
            {!user ? (
              <>
                <Button
                  onClick={() => {
                    navigate(`/login`);
                    toggleDrawer();
                  }}
                  variant="outlined"
                  color="info"
                >
                  {t("login")}
                </Button>
                <Button
                  onClick={() => {
                    navigate(`/signup`);
                    toggleDrawer();
                  }}
                  variant="contained"
                  color="info"
                >
                  {t("signup")}
                </Button>
              </>
            ) : (
              <Button
                fullWidth
                style={{ boxShadow: "none" }}
                variant="contained"
                onClick={() => {
                  AuthService.logout();
                  toggleDrawer();
                }}
                color="info"
              >
                {t("logout")}
              </Button>
            )}
          </Stack>
        }
      </div>
    </Box>
  );

  return (
    <div>
      <>
        <Drawer anchor="top" open={state} onClose={toggleDrawer}>
          {list(state)}
        </Drawer>
      </>
    </div>
  );
}
